module.exports = __webpack_public_path__ + "static/img/dialog_3.7d1d202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/aprilfoolsday/dialog/dialog_3.png
// module id = L4nK
// module chunks = 1